import {stateData, reduxState} from '../../values';

const initialState = {
    contacts:       [],
    status:         stateData.state1,
    contactsEdit:   [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_contacts){
        return {
            ...state,
            contacts:   action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_contacts){
        return {
            ...state,
            contactsEdit: action.payload
        }
    }
    return state
}
export default reducer